import { getLaunchDarklyEnvOptions } from './app';

// `satisfies` rather than a type annotation so the keys stay literal and a
// typo'd flag name stays a compile error.
const FEATURE_FLAG_DEFAULTS = {
  ONB_MOBILE_FORM: false,
} satisfies Record<string, boolean>;

type FeatureFlags = keyof typeof FEATURE_FLAG_DEFAULTS;

export const FEATURE_FLAGS: { [FeatureFlag in FeatureFlags]: FeatureFlag } =
  Object.keys(FEATURE_FLAG_DEFAULTS).reduce(
    (acc, featureFlag) => {
      return { ...acc, [featureFlag]: featureFlag };
    },
    {} as { [FeatureFlag in FeatureFlags]: FeatureFlag },
  );

export const FEATURE_FLAGS_OPTIONS = {
  defaults: FEATURE_FLAG_DEFAULTS,
  options: {
    ...getLaunchDarklyEnvOptions(),
    project: 'onboarding',
    kind: 'user',
    debug: false,
  },
};
